import React, { useContext, useEffect, useState } from 'react';
import { getSaleItems } from '../services/salesServices';
import { addScrap, updateProduct } from '../services/catalogServices';
import Toast from '../helpers/Toast';
import Spinner from '../helpers/Spinner';
import '../../styles/sales.css';
import Product from '../sales/Product';
import { AuthContext } from '../../context/Auth.context';
import { Link } from 'react-router-dom';
import beep_file from '../../assets/sounds/beep.wav';
import { getID } from '../functions/getID';

let beep = new Audio(beep_file);

const ProductTaxes = () => {

    const [saleitems, setSaleItems] = useState([]);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const { state, CheckResponse, setConfig } = useContext(AuthContext);
    const [current_product, setCurrentProduct] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(false);
    const [modal_taxes_preview, setModalTaxesPreview] = useState(false);
    const [taxes, setTaxes] = useState(false);

    useEffect(() => {
        loadSaleItems();
    }, []);

    const showToast = (t, d, tt, dd = 5) => {
        setList([...list, {
            id: getID(),
            title: t,
            description: d,
            type: tt,
            short: true,
            delete: dd
        }]);
    }

    const loadSaleItems = () => {
        setLoading(true);
        getSaleItems(state.auth).then(data => {
            CheckResponse(data);
            if (data.code == 200) {
                if (data.data.length > 0) {
                    setSelectedCategory(data.data[0].name);
                }
                setSaleItems(data.data);
                setDefaultPaymentMethod(data.payments[0].id);
                setConfig(data.config);
            } else {
                showToast('Oops!', 'Algo salio mal!', 'danger');
            }

            setLoading(false);
        });
    }

    const openTaxesModal = (product) => {
        setCurrentProduct(product);
        setSelectedProduct(true);
        setTaxes(product.taxes === 0 ? false : true);
        setModalTaxesPreview((modal_preview) => !modal_preview);
    }

    const closeTaxesModal = () => {
        setCurrentProduct([]);
        setSelectedProduct(false);
        setModalTaxesPreview((modal_preview) => !modal_preview);
    }

    const updateTexesProduct = () => {
        let productTaxes = current_product.taxes === 0 ? false : true;
        if (taxes === productTaxes) {
            closeTaxesModal();
            showToast('Hecho!', 'Impuestos actualizados!', 'success', 3);
        } else {
            const updatedProduct = { ...current_product, taxes: taxes ? 1 : 0 };
            console.log(productTaxes,  taxes ? 1 : 0)
            setCurrentProduct(updatedProduct);
            updateProduct(state.auth, updatedProduct).then(data => {
                CheckResponse(data);
                if (data.code === 200) {
                    closeTaxesModal();
                    showToast('Hecho!', 'Guardado con éxito', 'success');
                } else {
                    closeTaxesModal();
                    setLoading(false);
                    showToast('Oops!', 'Algo salió mal!', 'danger');
                }
            }).then(
                loadSaleItems()
            );
        }
    }

    return (
        <>
            <h1>Impuetos</h1>
            {!loading && <div>
                <Toast toastList={list} />
                {saleitems.length > 0 && <div className="col-sm-8 w-100 px-5 mt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            {saleitems.map(category =>
                                <button key={category.name} className={`btn ${selectedCategory == category.name ? 'btn-light' : 'btn-primary'}  ms-1 mb-1`} type="button" onClick={() => { setSelectedCategory(category.name) }}>
                                    {category.name}
                                </button>
                            )}
                        </div>
                    </div>
                    {saleitems.map(category =>
                        <div key={category.name} className={`row mt-2 collapse ${selectedCategory == category.name ? 'show' : ''}`}>
                            <>
                                {category.products.length > 0 && category.products && category.products.map && category.products.map(product =>
                                    <Product key={product.id} add={openTaxesModal} product={product}></Product>
                                )}
                                {category.products.length == 0 &&
                                    <div className="col-sm-12 text-center">
                                        <h2 className=' mt-4'>No hay productos</h2>
                                        <Link to="/catalogs/product/" className="btn btn-primary mt-2">Agregar</Link>
                                    </div>}
                            </>
                        </div>
                    )}

                </div>}
                {saleitems.length == 0 && <div className="col-sm-8 text-center">
                    <h2 className=' mt-4'>No hay categorias</h2>
                    <Link to="/catalogs/category/" className="btn btn-primary mt-2">Agregar</Link>
                </div>}
            </div>}

            {loading && <Spinner size={8} margin={4}></Spinner>}

            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_taxes_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    {!loading && <>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Impuestos para: {selectedProduct && current_product.name}</h5>
                                <button onClick={() => { closeTaxesModal() }} type="button" className="btn-close"></button>
                            </div>
                            <div className="modal-body">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="taxesRadio" id="taxesRadio1" checked={taxes === true} onChange={() => setTaxes(true)} />
                                    <label class="form-check-label" for="taxesRadio1">
                                        IVA 16%
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="taxesRadio" id="taxesRadio2" checked={taxes === false} onChange={() => setTaxes(false)} />
                                    <label class="form-check-label" for="taxesRadio2">
                                        Exento de impuestos
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button onClick={() => { closeTaxesModal() }} className="btn btn-danger" type="button">Cancelar</button>
                                <button type="button" onClick={() => { updateTexesProduct() }} className="btn btn-success">Actualizar impuetsos</button>
                            </div>
                        </div>
                    </>}
                </div>
            </div>
        </>
    );
}

export default ProductTaxes;